import { ReducerState } from "../../../state/reducers/types"
import { addOrUpdate, remove } from "../../../state/reducers/utils"
import { ActionType, PurchasesAction } from './actionTypes'
import { PurchaseOrder, Supplier } from "./types"

export type PurchasesState = {
    purchases: PurchaseOrder[]
    suppliers: Supplier[]
    currentPurchase?: PurchaseOrder
}

const initialState: PurchasesState = {
    purchases: [],
    suppliers: [],
}

const reducer = (state = initialState, action: PurchasesAction) => {
    switch(action.type) {
        case ActionType.UPDATE_PURCHASES:
            return { 
                ...state,
                purchases: addOrUpdate(state, action, 'purchases' as keyof ReducerState)
            }
        case ActionType.REMOVE_PURCHASES:
            return { 
                ...state,
                purchases: remove(state, action, 'purchases' as keyof ReducerState)
            }
        case ActionType.UPDATE_SUPPLIERS:
            return { 
                ...state,
                suppliers: addOrUpdate(state, action, 'suppliers' as keyof ReducerState)
            }
        case ActionType.REMOVE_SUPPLIERS:
            return { 
                ...state,
                suppliers: remove(state, action, 'suppliers' as keyof ReducerState)
            }
        case ActionType.SET_CURRENT_PURCHASE:
            return { 
                ...state,
                currentPurchase: action.payload
            }
        default:
            return state
    }
}

export default reducer
